define(["require", "exports", "log", "knockout", "../../utils/dateUtils"], function (require, exports, log, ko, DateUtils) {
    "use strict";
    var DateRangeModel = /** @class */ (function () {
        function DateRangeModel(data) {
            this.startDate = ko.observable(DateUtils.firstDayOfMonth());
            this.endDate = ko.observable(DateUtils.lastDayOfMonth());
            this.type = ko.observable('month'); //week, lastWeek, month, lastMonth, 2months, range
            this.displayText = ko.observable('This month');
            var self = this;
        }
        DateRangeModel.prototype.changeType = function (selectedType) {
            var self = this;
            self.type(selectedType);
            switch (selectedType) {
                case "week":
                    self.displayText("This week");
                    self.startDate(DateUtils.firstDayOfWeek());
                    self.endDate(DateUtils.lastDayOfWeek());
                    break;
                case "lastWeek":
                    self.displayText("Last week");
                    self.startDate(DateUtils.firstDayOfWeek(DateUtils.addDays(new Date(), -7)));
                    self.endDate(DateUtils.lastDayOfWeek(DateUtils.addDays(new Date(), -7)));
                    break;
                case "month":
                    self.displayText("This month");
                    self.startDate(DateUtils.firstDayOfMonth());
                    self.endDate(DateUtils.lastDayOfMonth());
                    break;
                case "lastMonth":
                    self.displayText("Last month");
                    self.startDate(DateUtils.firstDayOfMonth(DateUtils.addMonths(new Date(), -1)));
                    self.endDate(DateUtils.lastDayOfMonth(DateUtils.addMonths(new Date(), -1)));
                    break;
                case "2months":
                    self.displayText("Last 2 months");
                    self.startDate(DateUtils.firstDayOfMonth(DateUtils.addMonths(new Date(), -2)));
                    self.endDate(DateUtils.lastDayOfMonth(DateUtils.addMonths(new Date(), -1)));
                    break;
                default:
            }
            log.log(self.startDate(), self.endDate());
            if (self.action) {
                self.action();
            }
        };
        return DateRangeModel;
    }());
    return DateRangeModel;
});
//# sourceMappingURL=DateRangeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/components/DateRangeModel.js
// module id = 164
// module chunks = 2